import { createSlice, createAction } from "@reduxjs/toolkit";

export const getUserFiltersData = createAction("userFilters/getUserFiltersData");
export const deleteUserFilterByMake = createAction("userFilters/deleteUserFilterByMake");
export const saveUserFiltersData = createAction("userFilters/saveUserFiltersData");

const userFiltersSlice = createSlice({
  name: "userFiltersStore",
  initialState: {
    filters: [],
    loading: false,
    error: null
  },
  reducers: {
    setUserFilters: (state, action) => {
      state.filters = action.payload;
      state.loading = false;
      state.error = null;
    },
    setUserFiltersLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setUserFiltersError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  setUserFilters,
  setUserFiltersLoading,
  setUserFiltersError
} = userFiltersSlice.actions;

export default userFiltersSlice.reducer;
